import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card, CardBody, Button, Alert, FormGroup, Label, Input, Spinner } from 'reactstrap';
import Select from 'react-select';
import Page from '../../../../components/Page';
import Steps from '../../../../components/Generales/Steps';
import LoadingScreen from 'react-loading-screen';
import logo from '../../../../assets/img/logo/logo_aig_login-2.png';
import ValoresCotizacionMoto from '../../components/ValoresCotizacionMoto';
import { obtenerCotizacionMoto, limpiarDatosCotizacion } from '../../redux/aMotos';
import { FetchGuardarDatosFacturacion } from '../../../../redux/actions/aCotizacion';
import { httpClient } from '../../../../api/httpClient';
import { urlConsultarCedulaMotos, urlListarProvinciasMotos } from '../../api/urls';
import { urlListarCiudades, ambienteAplicacion } from '../../../../constants/urls';

const SpinnerCircularFacturacion = () => (
    <svg
        style={{
            width: '16px',
            height: '16px',
            animation: 'spinMotosFact 0.75s linear infinite',
            display: 'inline-block',
            verticalAlign: 'middle'
        }}
        viewBox="0 0 24 24"
        fill="none"
    >
        <circle
            cx="12"
            cy="12"
            r="10"
            stroke="#001871"
            strokeOpacity="0.25"
            strokeWidth="3"
        />
        <path
            fill="#001871"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
    </svg>
);

const OPCIONES_TIPO_DOC = [
    { value: '1', label: 'Cédula' },
    { value: '2', label: 'Ruc' },
    { value: '3', label: 'Pasaporte' }
];

const OPCIONES_ESTADO_CIVIL = [
    { value: '1', label: 'SOLTERO(A)' },
    { value: '2', label: 'CASADO(A)' },
    { value: '3', label: 'UNIÓN LIBRE' },
    { value: '4', label: 'DIVORCIADO(A)' },
    { value: '5', label: 'VIUDO(A)' },
    { value: '0', label: 'CONVERSIÓN' }
];

const OPCIONES_GENERO = [
    { value: '1', label: 'MASCULINO' },
    { value: '2', label: 'FEMENINO' }
];

const OPCIONES_PERSONERIA = [
    { value: '2', label: 'Jurídica' },
    { value: '1', label: 'Natural' }
];

const mapearEstadoCivil = (estadoCivil, tipoDocumento, personeria) => {
    var tipoDocVal = (tipoDocumento && typeof tipoDocumento === 'object') ? tipoDocumento.value : String(tipoDocumento || '');
    var persVal = (personeria && typeof personeria === 'object') ? personeria.value : String(personeria || '');
    var val = (estadoCivil && typeof estadoCivil === 'object') ? estadoCivil.value : String(estadoCivil || '');
    var valUpper = String(val).toUpperCase().trim();

    if (valUpper === '0' || valUpper.indexOf('CONV') !== -1) return '0';
    if (valUpper === '1' || valUpper === 'SOL' || valUpper.indexOf('SOL') !== -1) return '1';
    if (valUpper === '2' || valUpper === 'CAS' || valUpper.indexOf('CAS') !== -1) return '2';
    if (valUpper === '3' || valUpper === 'UNI' || valUpper.indexOf('UNI') !== -1 || valUpper.indexOf('LIBRE') !== -1) return '3';
    if (valUpper === '4' || valUpper === 'DIV' || valUpper.indexOf('DIV') !== -1) return '4';
    if (valUpper === '5' || valUpper === 'VIU' || valUpper.indexOf('VIU') !== -1) return '5';

    if (persVal === '2' || tipoDocVal === '2') return '0'; // CONVERSION para RUC o casos no naturales / jurídicos
    return '1'; // Default soltero
};

const mapearGenero = (genero, tipoDocumento) => {
    var val = (genero && typeof genero === 'object') ? genero.value : String(genero || '');
    var valUpper = String(val).toUpperCase().trim();

    if (valUpper === '2' || valUpper === 'FEM' || valUpper.indexOf('F') === 0) return '2';
    // 1 => MASCULINO (por defecto para casos de RUC, personas jurídicas o masculino)
    return '1';
};

/**
 * Paso 3 / 4: Confirmación y Datos del Contratante / Facturación (Seguro de Motos).
 * Réplica idéntica del diseño estándar de Cotizacion4Confirmacion de AIG.
 */
const FacturacionMoto = ({
    history,
    location,
    obtenerCotizacionMoto,
    limpiarDatosCotizacion,
    guardarDatosFacturacionAction,
    estadoMotos
}) => {
    const [cargando, setCargando] = useState(true);
    const [guardando, setGuardando] = useState(false);
    const [mismosDatos, setMismosDatos] = useState(true);
    const [errorMsg, setErrorMsg] = useState(null);
    const [consultandoDinardap, setConsultandoDinardap] = useState(false);
    const [consultandoDinardapFact, setConsultandoDinardapFact] = useState(false);
    const ultimaConsultaContratanteRef = useRef('');
    const ultimaConsultaFacturacionRef = useRef('');
    const identificacionContratanteRef = useRef('');
    const identificacionFacturacionRef = useRef('');

    // Listas de provincias y ciudades
    const [provincias, setProvincias] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [ciudadesF, setCiudadesF] = useState([]);

    // Datos del Contratante
    const [datosContratante, setDatosContratante] = useState({
        tipoDocumento: { value: '1', label: 'Cédula' },
        identificacion: '',
        nombres: '',
        apellidos: '',
        estadoCivil: null,
        genero: null,
        provincia: null,
        ciudad: null,
        fechaNacimiento: '',
        correo: '',
        direccion: '',
        celular: ''
    });

    // Datos de Facturación (si difiere)
    const [datosFacturacion, setDatosFacturacion] = useState({
        tipoDocumento: { value: '1', label: 'Cédula' },
        personeria: { value: '1', label: 'Natural' },
        identificacion: '',
        nombres: '',
        apellidos: '',
        estadoCivil: null,
        genero: null,
        fechaNacimiento: '',
        provincia: null,
        ciudad: null,
        correo: '',
        direccion: '',
        celular: '',
        fechaEmisionPasaporte: '',
        fechaCaducidadPasaporte: '',
        fechaIngresoPais: ''
    });

    const [errores, setErrores] = useState({});

    // Stepper oficial del Portal AIG
    const listaOpciones = [
        { id: 0, label: 'Cotización', value: 'cotizacion' },
        { id: 1, label: 'Resumen', value: 'resumen' },
        { id: 2, label: 'Confirmación', value: 'confirmacion' },
        { id: 3, label: 'Forma de Pago', value: 'forma-pago' },
        { id: 4, label: 'Formulario de Vinculación', value: 'formulario-vinculacion' },
        { id: 5, label: 'Emisión', value: 'emision' }
    ];

    var searchStr = (location && location.search) || (window.location && window.location.search) || '';
    var queryParams = new URLSearchParams(searchStr);
    var idCarrito = queryParams.get('idCarrito') || queryParams.get('id');

    // 1. Cargar Provincias
    useEffect(() => {
        var cargarProvincias = async () => {
            try {
                var res = await httpClient.get(urlListarProvinciasMotos);
                var provList = (res && (res.provincias || res.data)) || [];
                if (Array.isArray(provList) && provList.length > 0) {
                    var provs = provList.map(function(p) {
                        var val = String(p.provCodigoCore || p.provCodigo || p.proCodigoCore || p.proCodigo || p.id || p.codigo || '');
                        var lbl = p.provNombre || p.proNombre || p.nombre || p.descripcion || val;
                        return {
                            value: val,
                            label: lbl
                        };
                    });
                    setProvincias(provs);
                }
            } catch (e) {
                console.error('Error cargando provincias:', e);
            }
        };
        cargarProvincias();
    }, []);

    // 2. Cargar Cotización y precargar datos del Asegurado
    useEffect(() => {
        var cargarInformacion = async () => {
            if (idCarrito) {
                setCargando(true);
                limpiarDatosCotizacion();
                var res = await obtenerCotizacionMoto(idCarrito);
                setCargando(false);

                if (res && res.exito && res.data) {
                    var da = res.data.datosAsegurado || (res.data.carrito && res.data.carrito.datosAsegurado) || {};
                    var v = res.data.datosVehiculo || {};
                    
                    var nombresSplit = (da.nombres || '').trim().split(' ');
                    var nom = '';
                    var ape = '';
                    if (nombresSplit.length >= 2) {
                        nom = nombresSplit.slice(0, Math.ceil(nombresSplit.length / 2)).join(' ');
                        ape = nombresSplit.slice(Math.ceil(nombresSplit.length / 2)).join(' ');
                    } else {
                        nom = da.nombres || '';
                        ape = da.apellidos || '';
                    }

                    var estCivilOpt = null;
                    if (da.estadoCivil) {
                        var ecVal = typeof da.estadoCivil === 'object' ? (da.estadoCivil.value || '') : da.estadoCivil;
                        var ecTarget = mapearEstadoCivil(ecVal, da.tipoDocumento);
                        estCivilOpt = OPCIONES_ESTADO_CIVIL.find(function(o) { return o.value === ecTarget; }) || null;
                    }

                    var genOpt = null;
                    if (da.genero) {
                        var gVal = typeof da.genero === 'object' ? (da.genero.value || '') : da.genero;
                        var gTarget = mapearGenero(gVal, da.tipoDocumento);
                        genOpt = OPCIONES_GENERO.find(function(o) { return o.value === gTarget; }) || null;
                    }

                    setDatosContratante({
                        tipoDocumento: { value: '1', label: 'Cédula' },
                        identificacion: da.identificacion || '',
                        nombres: nom || da.nombres || '',
                        apellidos: ape || da.apellidos || '',
                        estadoCivil: estCivilOpt,
                        genero: genOpt,
                        provincia: v.provincia ? { value: String(v.provincia), label: v.provinciaNombre || String(v.provincia) } : null,
                        ciudad: null,
                        fechaNacimiento: da.fechaNacimiento || '',
                        correo: da.correo || '',
                        direccion: da.direccion || '',
                        celular: da.celular || ''
                    });

                    identificacionContratanteRef.current = da.identificacion || '';
                    ultimaConsultaContratanteRef.current = da.identificacion || '';

                    // Cargar ciudades si hay provincia precargada
                    if (v.provincia) {
                        cargarCiudadesPorProvincia(String(v.provincia), false);
                    }
                }
            } else {
                setCargando(false);
            }
        };
        cargarInformacion();
    }, [idCarrito]);

    // Función para cargar ciudades
    var cargarCiudadesPorProvincia = async function(codProvincia, esFacturacion) {
        if (!codProvincia) return;
        try {
            var url = urlListarCiudades + codProvincia;
            var res = await httpClient.get(url);
            var citsList = (res && (res.ciudades || res.cantones || res.data)) || [];
            if (Array.isArray(citsList)) {
                var cits = citsList.map(function(c) {
                    var val = String(c.ciuCodigoCore || c.ciuCodigo || c.cantonCodigoCore || c.cantonCodigo || c.id || c.codigo || '');
                    var lbl = c.ciuNombre || c.cantonNombre || c.nombre || c.descripcion || c.label || val;
                    return {
                        value: val,
                        label: lbl
                    };
                });
                if (esFacturacion) {
                    setCiudadesF(cits);
                } else {
                    setCiudades(cits);
                }
            }
        } catch (e) {
            console.error('Error cargando ciudades:', e);
        }
    };

    const isGlobalLoading = cargando || (estadoMotos && estadoMotos.isLoading);
    var idCotizacion = (estadoMotos && estadoMotos.idCotizacion) || (estadoMotos && estadoMotos.cotizacion && estadoMotos.cotizacion.idCotizacion) || '';
    var valorTot = (estadoMotos && (estadoMotos.valorTotal || (estadoMotos.carrito && estadoMotos.carrito.valorTotal))) || null;

    var handleRegresar = function() {
        if (history) {
            var currentId = idCarrito || (estadoMotos && estadoMotos.idCarrito);
            history.push('/motos/resumen' + (currentId ? ('?idCarrito=' + currentId) : ''));
        }
    };

    // Extrae campos de persona independientemente de la estructura retornada por el servicio
    var extractPersonaData = function(data) {
        if (!data) return null;
        var dp = data.datosPersona || data.formulario || data.data || data.resultado || data;

        // Nombres y Apellidos (soporta también razón social para empresas/RUC)
        var nombres = dp.razon_social || dp.razonSocial || data.razon_social || data.razonSocial || dp.cliNombres || dp.nombres || dp.nombre || data.cliNombres || data.nombres || data.nombre || '';
        var apellidos = dp.cliApellidos || dp.apellidos || dp.apellido || data.cliApellidos || data.apellidos || data.apellido || '';

        // Si viene separado en nombre1, nombre2 / apellido1, apellido2
        var n1 = ((dp.nombre1 || data.nombre1 || '') + ' ' + (dp.nombre2 || data.nombre2 || '')).trim();
        var a1 = ((dp.apellido1 || data.apellido1 || '') + ' ' + (dp.apellido2 || data.apellido2 || '')).trim();
        if (n1) nombres = n1;
        if (a1) apellidos = a1;

        if (!apellidos && nombres) {
            var partes = nombres.trim().split(' ');
            if (partes.length >= 2) {
                nombres = partes.slice(0, Math.ceil(partes.length / 2)).join(' ');
                apellidos = partes.slice(Math.ceil(partes.length / 2)).join(' ');
            }
        }

        // Fecha de Nacimiento / Constitución
        var fechaNac = dp.fecha_nacimiento || dp.fechaNacimiento || dp.fnacimiento || dp.fecha_constitucion || dp.fechaConstitucion || data.fecha_nacimiento || data.fechaNacimiento || data.fnacimiento || data.fecha_constitucion || data.fechaConstitucion || '';
        if (fechaNac && fechaNac.indexOf('/') !== -1) {
            var p = fechaNac.split('/');
            if (p.length === 3) {
                fechaNac = p[2] + '-' + (p[1].length === 1 ? '0' + p[1] : p[1]) + '-' + (p[0].length === 1 ? '0' + p[0] : p[0]);
            }
        }

        // Género
        var genRaw = dp.genero || dp.codigo_genero || data.genero || data.codigo_genero || '';
        var generoOpt = null;
        if (genRaw) {
            var gTarget = mapearGenero(genRaw);
            generoOpt = OPCIONES_GENERO.find(function(g) { return g.value === gTarget; }) || null;
        }

        // Estado Civil
        var ecRaw = dp.estado_civil || dp.codigo_estado_civil || dp.cliEstadoCivil || data.estado_civil || data.codigo_estado_civil || data.cliEstadoCivil || '';
        var estadoCivilOpt = null;
        if (ecRaw) {
            var ecTarget = mapearEstadoCivil(ecRaw);
            estadoCivilOpt = OPCIONES_ESTADO_CIVIL.find(function(e) {
                return e.value === ecTarget;
            }) || null;
        }

        // Celular
        var celular = dp.telefono_celular || dp.celular || dp.cliCelular || dp.celulares || data.telefono_celular || data.celular || data.cliCelular || data.celulares || '';

        // Dirección
        var direccion = dp.direccion || dp.direcciones || dp.cliDireccion || data.direccion || data.direcciones || data.cliDireccion || '';

        return {
            nombres: nombres ? nombres.toUpperCase() : '',
            apellidos: apellidos ? apellidos.toUpperCase() : '',
            fechaNacimiento: fechaNac || '',
            genero: generoOpt,
            estadoCivil: estadoCivilOpt,
            celular: celular || '',
            direccion: direccion ? direccion.toUpperCase() : ''
        };
    };

    // Autocompletado DINARDAP para Contratante
    var handleConsultarDinardapContratante = async function(docParam) {
        var doc = (docParam !== undefined && docParam !== null ? docParam : identificacionContratanteRef.current || datosContratante.identificacion || '').trim();
        if (!doc || doc.length < 10) return;

        if (ultimaConsultaContratanteRef.current === doc) return;
        ultimaConsultaContratanteRef.current = doc;

        setConsultandoDinardap(true);
        setErrorMsg(null);
        try {
            var url = urlConsultarCedulaMotos + doc + '&ramo=vehiculos';
            var res = await httpClient.get(url);
            
            if (res && res.transaccion !== false) {
                var persona = extractPersonaData(res);
                if (persona && (persona.nombres || persona.apellidos || persona.fechaNacimiento)) {
                    setDatosContratante(function(prev) {
                        var nuevos = Object.assign({}, prev);
                        nuevos.identificacion = doc;
                        if (persona.nombres) nuevos.nombres = persona.nombres;
                        if (persona.apellidos) nuevos.apellidos = persona.apellidos;
                        if (persona.fechaNacimiento) nuevos.fechaNacimiento = persona.fechaNacimiento;
                        if (persona.genero) nuevos.genero = persona.genero;
                        if (persona.estadoCivil) nuevos.estadoCivil = persona.estadoCivil;
                        if (persona.celular && !nuevos.celular) nuevos.celular = persona.celular;
                        if (persona.direccion && !nuevos.direccion) nuevos.direccion = persona.direccion;
                        return nuevos;
                    });
                }
            } else {
                ultimaConsultaContratanteRef.current = '';
            }
        } catch (e) {
            console.error('Error consultando DINARDAP:', e);
            ultimaConsultaContratanteRef.current = '';
        } finally {
            setConsultandoDinardap(false);
        }
    };

    // Autocompletado DINARDAP para Facturación (si difiere)
    var handleConsultarDinardapFacturacion = async function(docParam) {
        var doc = (docParam !== undefined && docParam !== null ? docParam : identificacionFacturacionRef.current || datosFacturacion.identificacion || '').trim();
        var esPasaporte = datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '3';
        if (esPasaporte || !doc || doc.length < 10) return;

        if (ultimaConsultaFacturacionRef.current === doc) return;
        ultimaConsultaFacturacionRef.current = doc;

        setConsultandoDinardapFact(true);
        try {
            var url = urlConsultarCedulaMotos + doc + '&ramo=vehiculos';
            var res = await httpClient.get(url);
            if (res && res.transaccion !== false) {
                var persona = extractPersonaData(res);
                if (persona && (persona.nombres || persona.apellidos)) {
                    var esRuc = datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '2';
                    setDatosFacturacion(function(prev) {
                        var nuevos = Object.assign({}, prev);
                        nuevos.identificacion = doc;
                        if (persona.nombres) nuevos.nombres = persona.nombres;
                        if (!esRuc && persona.apellidos) nuevos.apellidos = persona.apellidos;
                        if (persona.direccion && !nuevos.direccion) nuevos.direccion = persona.direccion;
                        if (persona.celular && !nuevos.celular) nuevos.celular = persona.celular;
                        if (!esRuc && persona.estadoCivil) nuevos.estadoCivil = persona.estadoCivil;
                        if (!esRuc && persona.genero) nuevos.genero = persona.genero;
                        if (persona.fechaNacimiento) nuevos.fechaNacimiento = persona.fechaNacimiento;
                        return nuevos;
                    });
                }
            } else {
                ultimaConsultaFacturacionRef.current = '';
            }
        } catch (e) {
            console.error('Error consultando DINARDAP Facturación:', e);
            ultimaConsultaFacturacionRef.current = '';
        } finally {
            setConsultandoDinardapFact(false);
        }
    };

    var handleCampoContratanteChange = function(campo, valor) {
        if (campo === 'identificacion') {
            identificacionContratanteRef.current = valor;
            if (valor !== ultimaConsultaContratanteRef.current) {
                ultimaConsultaContratanteRef.current = '';
            }
        }

        setDatosContratante(function(prev) {
            var nuevos = Object.assign({}, prev);
            nuevos[campo] = valor;
            if (campo === 'provincia') {
                nuevos.ciudad = null;
            }
            return nuevos;
        });

        if (campo === 'provincia') {
            if (valor && valor.value) {
                cargarCiudadesPorProvincia(valor.value, false);
            } else {
                setCiudades([]);
            }
        }

        if (errores[campo]) {
            setErrores(function(prevErr) {
                var nuevosErr = Object.assign({}, prevErr);
                delete nuevosErr[campo];
                return nuevosErr;
            });
        }
    };

    var handleCampoFacturacionChange = function(campo, valor) {
        if (campo === 'identificacion') {
            identificacionFacturacionRef.current = valor;
            if (valor !== ultimaConsultaFacturacionRef.current) {
                ultimaConsultaFacturacionRef.current = '';
            }
        }

        if (campo === 'tipoDocumento') {
            var tipoVal = (valor && valor.value) || '1';
            setDatosFacturacion(function(prev) {
                var nuevos = Object.assign({}, prev);
                nuevos.tipoDocumento = valor;
                if (tipoVal === '2') {
                    // RUC: personería jurídica por defecto
                    nuevos.personeria = { value: '2', label: 'Jurídica' };
                    nuevos.apellidos = '';
                    nuevos.estadoCivil = null;
                    nuevos.genero = null;
                    nuevos.fechaEmisionPasaporte = '';
                    nuevos.fechaCaducidadPasaporte = '';
                    nuevos.fechaIngresoPais = '';
                } else if (tipoVal === '3') {
                    // Pasaporte: personería natural
                    nuevos.personeria = { value: '1', label: 'Natural' };
                } else {
                    // Cédula: personería natural
                    nuevos.personeria = { value: '1', label: 'Natural' };
                    nuevos.fechaEmisionPasaporte = '';
                    nuevos.fechaCaducidadPasaporte = '';
                    nuevos.fechaIngresoPais = '';
                }
                return nuevos;
            });

            // Limpiar errores no aplicables al cambiar tipo
            setErrores(function(prevErr) {
                var nuevosErr = Object.assign({}, prevErr);
                delete nuevosErr.f_tipoDocumento;
                delete nuevosErr.f_personeria;
                delete nuevosErr.f_identificacion;
                delete nuevosErr.f_nombres;
                delete nuevosErr.f_apellidos;
                delete nuevosErr.f_estadoCivil;
                delete nuevosErr.f_genero;
                delete nuevosErr.f_fechaEmisionPasaporte;
                delete nuevosErr.f_fechaCaducidadPasaporte;
                delete nuevosErr.f_fechaIngresoPais;
                return nuevosErr;
            });
            return;
        }

        setDatosFacturacion(function(prev) {
            var nuevos = Object.assign({}, prev);
            nuevos[campo] = valor;
            if (campo === 'provincia') {
                nuevos.ciudad = null;
            }
            return nuevos;
        });

        if (campo === 'provincia') {
            if (valor && valor.value) {
                cargarCiudadesPorProvincia(valor.value, true);
            } else {
                setCiudadesF([]);
            }
        }

        if (errores['f_' + campo]) {
            setErrores(function(prevErr) {
                var nuevosErr = Object.assign({}, prevErr);
                delete nuevosErr['f_' + campo];
                return nuevosErr;
            });
        }
    };

    var validarFormulario = function() {
        var errs = {};

        // Validar Contratante
        if (!datosContratante.identificacion || datosContratante.identificacion.trim().length < 10) {
            errs.identificacion = 'Por favor ingrese el número de identificación';
        }
        if (!datosContratante.nombres || datosContratante.nombres.trim().length < 2) {
            errs.nombres = 'Por favor ingrese los nombres';
        }
        if (!datosContratante.apellidos || datosContratante.apellidos.trim().length < 2) {
            errs.apellidos = 'Por favor ingrese los apellidos';
        }
        if (!datosContratante.estadoCivil) {
            if (datosContratante.tipoDocumento && datosContratante.tipoDocumento.value === '2') {
                // Para RUC no es mandatorio estado civil (se enviará '0' CONVERSIÓN)
            } else {
                errs.estadoCivil = 'Por favor seleccione el estado civil';
            }
        }
        if (!datosContratante.genero) {
            errs.genero = 'Por favor seleccione el género';
        }
        if (!datosContratante.provincia) {
            errs.provincia = 'Por favor seleccione la provincia';
        }
        if (!datosContratante.ciudad) {
            errs.ciudad = 'Por favor seleccione la ciudad';
        }
        if (!datosContratante.fechaNacimiento) {
            errs.fechaNacimiento = 'Por favor ingrese la fecha de nacimiento';
        }
        if (!datosContratante.correo || datosContratante.correo.indexOf('@') === -1) {
            errs.correo = 'Por favor ingrese un correo electrónico válido';
        }
        if (!datosContratante.direccion || datosContratante.direccion.trim().length < 4) {
            errs.direccion = 'Por favor ingrese la dirección';
        }
        if (!datosContratante.celular || datosContratante.celular.trim().length < 9) {
            errs.celular = 'Por favor ingrese el número de celular';
        }

        // Si no son los mismos datos, validar Facturación
        if (!mismosDatos) {
            var esRucF = datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '2';
            var esPasaporteF = datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '3';

            if (!datosFacturacion.tipoDocumento) {
                errs.f_tipoDocumento = 'Por favor seleccione el tipo de documento';
            }
            if (esRucF && !datosFacturacion.personeria) {
                errs.f_personeria = 'Por favor seleccione la personería';
            }

            var idMinLen = esPasaporteF ? 3 : (esRucF ? 13 : 10);
            if (!datosFacturacion.identificacion || datosFacturacion.identificacion.trim().length < idMinLen) {
                errs.f_identificacion = esPasaporteF 
                    ? 'Por favor ingrese el número de pasaporte' 
                    : (esRucF ? 'Por favor ingrese un RUC válido (13 dígitos)' : 'Por favor ingrese una cédula válida (10 dígitos)');
            }

            if (esPasaporteF) {
                if (!datosFacturacion.fechaEmisionPasaporte) {
                    errs.f_fechaEmisionPasaporte = 'Por favor ingrese la fecha de expedición del pasaporte';
                }
                if (!datosFacturacion.fechaCaducidadPasaporte) {
                    errs.f_fechaCaducidadPasaporte = 'Por favor ingrese la fecha de vencimiento del pasaporte';
                }
                if (!datosFacturacion.fechaIngresoPais) {
                    errs.f_fechaIngresoPais = 'Por favor ingrese la fecha de ingreso al país';
                }
            }

            if (!datosFacturacion.nombres || datosFacturacion.nombres.trim().length < 2) {
                errs.f_nombres = esRucF ? 'Por favor ingrese la razón social' : 'Por favor ingrese los nombres';
            }
            if (!esRucF && (!datosFacturacion.apellidos || datosFacturacion.apellidos.trim().length < 2)) {
                errs.f_apellidos = 'Por favor ingrese los apellidos';
            }
            if (!esRucF && !datosFacturacion.estadoCivil) {
                errs.f_estadoCivil = 'Por favor seleccione el estado civil';
            }
            if (!esRucF && !datosFacturacion.genero) {
                errs.f_genero = 'Por favor seleccione el género';
            }
            if (!datosFacturacion.provincia) {
                errs.f_provincia = 'Por favor seleccione la provincia';
            }
            if (!datosFacturacion.ciudad) {
                errs.f_ciudad = 'Por favor seleccione la ciudad';
            }
            if (!datosFacturacion.fechaNacimiento) {
                errs.f_fechaNacimiento = esRucF ? 'Por favor ingrese la fecha de constitución' : 'Por favor ingrese la fecha de nacimiento';
            }
            if (!datosFacturacion.correo || datosFacturacion.correo.indexOf('@') === -1) {
                errs.f_correo = 'Por favor ingrese el correo para facturación electrónica';
            }
            if (!datosFacturacion.direccion || datosFacturacion.direccion.trim().length < 4) {
                errs.f_direccion = 'Por favor ingrese la dirección';
            }
            if (!datosFacturacion.celular || datosFacturacion.celular.trim().length < 9) {
                errs.f_celular = 'Por favor ingrese el teléfono celular';
            }
        }

        setErrores(errs);
        return Object.keys(errs).length === 0;
    };

    var handleContinuar = async function() {
        if (!validarFormulario()) {
            setErrorMsg('Por favor complete todos los campos obligatorios marcados en rojo.');
            return;
        }

        setGuardando(true);
        setErrorMsg(null);

        try {
            var currentId = idCarrito || (estadoMotos && estadoMotos.idCarrito);

            var dc = datosContratante;
            var df = datosFacturacion;
            var esRucF = df.tipoDocumento && df.tipoDocumento.value === '2';
            var esPasaporteF = df.tipoDocumento && df.tipoDocumento.value === '3';

            var datosContratanteEnviar = {
                cedula: dc.identificacion || '',
                cliNombres: dc.nombres || '',
                cliApellidos: dc.apellidos || '',
                correo: dc.correo || '',
                direccion: dc.direccion || '',
                celular: dc.celular || '',
                cliPersoneria: '1',
                codTipodocumento: (dc.tipoDocumento && dc.tipoDocumento.value) || '1',
                fechaNacimiento: dc.fechaNacimiento || '',
                codEstadoCivil: mapearEstadoCivil(dc.estadoCivil, dc.tipoDocumento),
                codGenero: mapearGenero(dc.genero, dc.tipoDocumento),
                codProvincia: (dc.provincia && dc.provincia.value) || '',
                codCiudad: (dc.ciudad && dc.ciudad.value) || ''
            };

            var datosFacturacionEnviar = mismosDatos ? {
                cedula: dc.identificacion || '',
                cliNombres: dc.nombres || '',
                cliApellidos: dc.apellidos || '',
                correo: dc.correo || '',
                direccion: dc.direccion || '',
                celular: dc.celular || '',
                cliPersoneria: '1',
                codTipodocumento: (dc.tipoDocumento && dc.tipoDocumento.value) || '1',
                fechaNacimiento: dc.fechaNacimiento || '',
                codEstadoCivil: mapearEstadoCivil(dc.estadoCivil, dc.tipoDocumento),
                codGenero: mapearGenero(dc.genero, dc.tipoDocumento),
                codProvincia: (dc.provincia && dc.provincia.value) || '',
                codCiudad: (dc.ciudad && dc.ciudad.value) || ''
            } : {
                cedula: df.identificacion || '',
                cliNombres: df.nombres || '',
                cliApellidos: esRucF ? '' : (df.apellidos || ''),
                correo: df.correo || '',
                direccion: df.direccion || '',
                celular: df.celular || '',
                cliPersoneria: esRucF ? ((df.personeria && df.personeria.value) || '2') : '1',
                codTipodocumento: (df.tipoDocumento && df.tipoDocumento.value) || '1',
                fechaNacimiento: df.fechaNacimiento || '',
                codEstadoCivil: esRucF ? '0' : mapearEstadoCivil(df.estadoCivil, df.tipoDocumento, df.personeria),
                codGenero: esRucF ? '1' : mapearGenero(df.genero, df.tipoDocumento),
                codProvincia: (df.provincia && df.provincia.value) || '',
                codCiudad: (df.ciudad && df.ciudad.value) || ''
            };

            if (!mismosDatos && esPasaporteF) {
                datosFacturacionEnviar.fechaEmisionPasaporte = df.fechaEmisionPasaporte || '';
                datosFacturacionEnviar.fechaCaducidadPasaporte = df.fechaCaducidadPasaporte || '';
                datosFacturacionEnviar.fechaIngresoPais = df.fechaIngresoPais || '';
            }

            var payload = {
                empresa: 'AIGMETROPOLITANA',
                plataforma: 'WEB',
                datosContratante: datosContratanteEnviar,
                datosPagadorFacturacion: datosFacturacionEnviar,
                idCarrito: currentId,
                ambiente: ambienteAplicacion || 'LOCAL'
            };

            var res = await guardarDatosFacturacionAction(payload);
            setGuardando(false);

            // Redirección al siguiente paso de formas de pago
            if (history) {
                history.push('/forma-pago?id=' + currentId);
            }
        } catch (err) {
            console.error('Error guardando datos de facturación:', err);
            setGuardando(false);
            setErrorMsg('Ocurrió un error al guardar los datos de facturación. Por favor intente nuevamente.');
        }
    };

    return (
        <LoadingScreen
            loading={isGlobalLoading || guardando}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text={guardando ? 'Guardando datos de facturación...' : 'Cargando información...'}
        >
            <div className="cr-content container-fluid">
                <div className="container-body-spaces">
                    <Page
                        title="Cotización de Motos"
                        breadcrumbs={[
                            { name: "Cotización De Motos", active: false },
                            { name: "Confirmación", active: true }
                        ]}
                    >
                        {/* Stepper Superior (6 Pasos estándar AIG) */}
                        <Row className="mb-3">
                            <Col lg={12} md={12} sm={12} xs={12}>
                                <Steps 
                                    tipo={'parametrico'} 
                                    listaOpciones={listaOpciones} 
                                    paso={'confirmacion'} 
                                />
                            </Col>
                        </Row>

                        {errorMsg && (
                            <Row>
                                <Col lg={12} md={12} sm={12} xs={12}>
                                    <Alert color="danger">
                                        {errorMsg}
                                    </Alert>
                                </Col>
                            </Row>
                        )}

                        {!isGlobalLoading && (
                            <Row style={{ alignItems: 'flex-start' }}>
                                {/* Columna Izquierda: Formulario Estándar Cotización 4 Confirmación */}
                                <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box">
                                    
                                    {/* Botón Regresar a Resumen */}
                                    <div className="mb-3">
                                        <Button 
                                            outline 
                                            color="secondary" 
                                            onClick={handleRegresar}
                                            style={{ 
                                                textTransform: 'uppercase', 
                                                fontSize: '13px', 
                                                fontWeight: 'bold',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #ced4da',
                                                color: '#333333',
                                                padding: '6px 14px'
                                            }}
                                        >
                                            <i className="fa fa-chevron-left mr-2" /> REGRESAR A RESUMEN
                                        </Button>
                                    </div>

                                    {/* Título de Cotización */}
                                    {idCotizacion && (
                                        <h4 style={{ fontWeight: 'bold', marginBottom: '14px', color: '#000000' }}>
                                            Cotización # {idCotizacion}
                                        </h4>
                                    )}

                                    {/* Card: Datos del Contratante */}
                                    <Card className="flex-row mb-4 shadow-sm" style={{ border: '1px solid #e0e0e0', borderRadius: '4px' }}>
                                        <CardBody style={{ padding: '24px' }}>
                                            <Row className="align-items-center mb-4">
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <h4 style={{ fontWeight: 'bold', margin: 0, color: '#000000' }}>
                                                        Datos del Contratante
                                                    </h4>
                                                </Col>
                                                <Col lg={4} md={4} sm={4} xs={12} className="text-right">
                                                    <span style={{ fontSize: '13px', color: '#666666' }}>(*) Campos Requeridos</span>
                                                </Col>
                                            </Row>

                                            {/* 1. Seleccione tipo de documento */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Seleccione tipo de documento(*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Select 
                                                        options={OPCIONES_TIPO_DOC}
                                                        value={datosContratante.tipoDocumento}
                                                        onChange={(opt) => handleCampoContratanteChange('tipoDocumento', opt)}
                                                        placeholder="Seleccione..."
                                                        isSearchable={false}
                                                    />
                                                </Col>
                                            </Row>

                                            {/* 2. Número de Identificación */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Número de Identificación (*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <div style={{ position: 'relative' }}>
                                                        <Input 
                                                            type="text"
                                                            value={datosContratante.identificacion}
                                                            onChange={(e) => {
                                                                var val = e.target.value.replace(/[^0-9a-zA-Z]/g, '');
                                                                handleCampoContratanteChange('identificacion', val);
                                                                if (val.length === 10 || val.length === 13) {
                                                                    handleConsultarDinardapContratante(val);
                                                                }
                                                            }}
                                                            onBlur={(e) => {
                                                                var val = (e.target.value || '').trim();
                                                                if (val && val.length >= 10 && val !== ultimaConsultaContratanteRef.current) {
                                                                    handleConsultarDinardapContratante(val);
                                                                }
                                                            }}
                                                            invalid={!!errores.identificacion}
                                                        />
                                                        {consultandoDinardap && (
                                                            <div style={{ position: 'absolute', right: '10px', top: '7px', zIndex: 5 }}>
                                                                <SpinnerCircularFacturacion />
                                                            </div>
                                                        )}
                                                    </div>
                                                    {errores.identificacion && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.identificacion}</span>}
                                                </Col>
                                            </Row>

                                            {/* 3. Nombres */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Nombres (*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Input 
                                                        type="text"
                                                        value={datosContratante.nombres}
                                                        onChange={(e) => handleCampoContratanteChange('nombres', e.target.value.toUpperCase())}
                                                        invalid={!!errores.nombres}
                                                    />
                                                    {errores.nombres && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.nombres}</span>}
                                                </Col>
                                            </Row>

                                            {/* 4. Apellidos */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Apellidos (*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Input 
                                                        type="text"
                                                        value={datosContratante.apellidos}
                                                        onChange={(e) => handleCampoContratanteChange('apellidos', e.target.value.toUpperCase())}
                                                        invalid={!!errores.apellidos}
                                                    />
                                                    {errores.apellidos && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.apellidos}</span>}
                                                </Col>
                                            </Row>

                                            {/* 5. Estado Civil */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Estado Civil(*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Select 
                                                        options={OPCIONES_ESTADO_CIVIL}
                                                        value={datosContratante.estadoCivil}
                                                        onChange={(opt) => handleCampoContratanteChange('estadoCivil', opt)}
                                                        placeholder="Seleccione..."
                                                        isSearchable={false}
                                                    />
                                                    {errores.estadoCivil && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.estadoCivil}</span>}
                                                </Col>
                                            </Row>

                                            {/* 6. Género */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Género(*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Select 
                                                        options={OPCIONES_GENERO}
                                                        value={datosContratante.genero}
                                                        onChange={(opt) => handleCampoContratanteChange('genero', opt)}
                                                        placeholder="Seleccione..."
                                                        isSearchable={false}
                                                    />
                                                    {errores.genero && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.genero}</span>}
                                                </Col>
                                            </Row>

                                            {/* 7. Provincia */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Provincia(*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Select 
                                                        options={provincias}
                                                        value={datosContratante.provincia}
                                                        onChange={(opt) => handleCampoContratanteChange('provincia', opt)}
                                                        placeholder="Seleccione una provincia"
                                                        isSearchable={true}
                                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                    />
                                                    {errores.provincia && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.provincia}</span>}
                                                </Col>
                                            </Row>

                                            {/* 8. Ciudad */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Ciudad(*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Select 
                                                        options={ciudades}
                                                        value={datosContratante.ciudad}
                                                        onChange={(opt) => handleCampoContratanteChange('ciudad', opt)}
                                                        placeholder="Seleccione una ciudad"
                                                        isSearchable={true}
                                                        isDisabled={!datosContratante.provincia}
                                                        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                    />
                                                    {errores.ciudad && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.ciudad}</span>}
                                                </Col>
                                            </Row>

                                            {/* 9. Fecha Nacimiento */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Fecha nacimiento(*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Input 
                                                        type="date"
                                                        value={datosContratante.fechaNacimiento}
                                                        onChange={(e) => handleCampoContratanteChange('fechaNacimiento', e.target.value)}
                                                        invalid={!!errores.fechaNacimiento}
                                                    />
                                                    {errores.fechaNacimiento && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.fechaNacimiento}</span>}
                                                </Col>
                                            </Row>

                                            {/* 10. Correo Electrónico */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Correo Electrónico (*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Input 
                                                        type="email"
                                                        value={datosContratante.correo}
                                                        onChange={(e) => handleCampoContratanteChange('correo', e.target.value)}
                                                        invalid={!!errores.correo}
                                                    />
                                                    {errores.correo && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.correo}</span>}
                                                </Col>
                                            </Row>

                                            {/* 11. Dirección */}
                                            <Row className="mb-3 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Dirección (*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Input 
                                                        type="text"
                                                        value={datosContratante.direccion}
                                                        onChange={(e) => handleCampoContratanteChange('direccion', e.target.value.toUpperCase())}
                                                        invalid={!!errores.direccion}
                                                    />
                                                    {errores.direccion && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.direccion}</span>}
                                                </Col>
                                            </Row>

                                            {/* 12. Celular */}
                                            <Row className="mb-2 align-items-center">
                                                <Col lg={4} md={4} sm={4} xs={12}>
                                                    <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                        Celular (*)
                                                    </h5>
                                                </Col>
                                                <Col lg={8} md={8} sm={8} xs={12}>
                                                    <Input 
                                                        type="text"
                                                        value={datosContratante.celular}
                                                        onChange={(e) => handleCampoContratanteChange('celular', e.target.value.replace(/[^0-9]/g, ''))}
                                                        invalid={!!errores.celular}
                                                    />
                                                    {errores.celular && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.celular}</span>}
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>

                                    {/* Card: Checkbox Mismos Datos Facturación */}
                                    <Card className="shadow-sm mb-4" style={{ border: '1px solid #e0e0e0', borderRadius: '4px' }}>
                                        <CardBody style={{ padding: '16px 24px' }}>
                                            <div 
                                                className="d-flex align-items-center" 
                                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                                onClick={() => setMismosDatos(!mismosDatos)}
                                            >
                                                <div 
                                                    style={{
                                                        width: '18px',
                                                        height: '18px',
                                                        border: '2px solid #001871',
                                                        borderRadius: '3px',
                                                        backgroundColor: mismosDatos ? '#001871' : '#ffffff',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginRight: '12px',
                                                        cursor: 'pointer',
                                                        transition: 'all 0.15s ease-in-out',
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    {mismosDatos && (
                                                        <i className="fa fa-check" style={{ color: '#ffffff', fontSize: '11px', fontWeight: 'bold' }} />
                                                    )}
                                                </div>
                                                <span
                                                    style={{
                                                        fontWeight: 'bold',
                                                        color: '#001871',
                                                        cursor: 'pointer',
                                                        fontSize: '15px'
                                                    }}
                                                >
                                                    ¿Desea utilizar los mismos datos para la Facturación?
                                                </span>
                                            </div>
                                        </CardBody>
                                    </Card>

                                    {/* Card: Datos de Facturación (si !mismosDatos) */}
                                    {!mismosDatos && (
                                        <Card className="flex-row mb-4 shadow-sm" style={{ border: '1px solid #e0e0e0', borderRadius: '4px' }}>
                                            <CardBody style={{ padding: '24px' }}>
                                                <Row className="align-items-center mb-4">
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <h4 style={{ fontWeight: 'bold', margin: 0, color: '#000000' }}>
                                                            Datos de Facturación
                                                        </h4>
                                                    </Col>
                                                    <Col lg={4} md={4} sm={4} xs={12} className="text-right">
                                                        <span style={{ fontSize: '13px', color: '#666666' }}>(*) Campos Requeridos</span>
                                                    </Col>
                                                </Row>

                                                {/* 1. Seleccione tipo de documento(*) */}
                                                <Row className="mb-3 align-items-center">
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                            Seleccione tipo de documento(*)
                                                        </h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Select 
                                                            options={OPCIONES_TIPO_DOC}
                                                            value={datosFacturacion.tipoDocumento}
                                                            onChange={(opt) => handleCampoFacturacionChange('tipoDocumento', opt)}
                                                            placeholder="Seleccione..."
                                                            isSearchable={false}
                                                        />
                                                        {errores.f_tipoDocumento && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_tipoDocumento}</span>}
                                                    </Col>
                                                </Row>

                                                {/* 2. Seleccione personería(*) (Solo cuando es Ruc) */}
                                                {datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '2' && (
                                                    <Row className="mb-3 align-items-center">
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                                Seleccione personería(*)
                                                            </h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Select 
                                                                options={OPCIONES_PERSONERIA}
                                                                value={datosFacturacion.personeria}
                                                                onChange={(opt) => handleCampoFacturacionChange('personeria', opt)}
                                                                placeholder="Seleccione..."
                                                                isSearchable={false}
                                                            />
                                                            {errores.f_personeria && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_personeria}</span>}
                                                        </Col>
                                                    </Row>
                                                )}

                                                {/* 3. Número de Identificación (*) */}
                                                <Row className="mb-3 align-items-center">
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                            Número de Identificación (*)
                                                        </h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <div style={{ position: 'relative' }}>
                                                            <Input 
                                                                type="text"
                                                                value={datosFacturacion.identificacion}
                                                                onChange={(e) => {
                                                                    var val = e.target.value.replace(/[^0-9a-zA-Z]/g, '');
                                                                    handleCampoFacturacionChange('identificacion', val);
                                                                    var esPasaporte = datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '3';
                                                                    if (!esPasaporte && (val.length === 10 || val.length === 13)) {
                                                                        handleConsultarDinardapFacturacion(val);
                                                                    }
                                                                }}
                                                                onBlur={(e) => {
                                                                    var val = (e.target.value || '').trim();
                                                                    var esPasaporte = datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '3';
                                                                    if (!esPasaporte && val && val.length >= 10 && val !== ultimaConsultaFacturacionRef.current) {
                                                                        handleConsultarDinardapFacturacion(val);
                                                                    }
                                                                }}
                                                                invalid={!!errores.f_identificacion}
                                                            />
                                                            {consultandoDinardapFact && (
                                                                <div style={{ position: 'absolute', right: '10px', top: '7px', zIndex: 5 }}>
                                                                    <SpinnerCircularFacturacion />
                                                                </div>
                                                            )}
                                                        </div>
                                                        <style>{`
                                                            @keyframes spinMotosFact {
                                                                0% { transform: rotate(0deg); }
                                                                100% { transform: rotate(360deg); }
                                                            }
                                                        `}</style>
                                                        {errores.f_identificacion && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_identificacion}</span>}
                                                    </Col>
                                                </Row>

                                                {/* Campos de Pasaporte (Solo si tipoDocumento === '3') */}
                                                {datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '3' && (
                                                    <React.Fragment>
                                                        {/* Fecha Expedición Pasaporte (*) */}
                                                        <Row className="mb-3 align-items-center">
                                                            <Col lg={4} md={4} sm={4} xs={12}>
                                                                <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                                    Fecha Expedición Pasaporte (*)
                                                                </h5>
                                                            </Col>
                                                            <Col lg={8} md={8} sm={8} xs={12}>
                                                                <Input 
                                                                    type="date"
                                                                    value={datosFacturacion.fechaEmisionPasaporte}
                                                                    onChange={(e) => handleCampoFacturacionChange('fechaEmisionPasaporte', e.target.value)}
                                                                    invalid={!!errores.f_fechaEmisionPasaporte}
                                                                />
                                                                {errores.f_fechaEmisionPasaporte && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_fechaEmisionPasaporte}</span>}
                                                            </Col>
                                                        </Row>

                                                        {/* Fecha Vencimiento Pasaporte (*) */}
                                                        <Row className="mb-3 align-items-center">
                                                            <Col lg={4} md={4} sm={4} xs={12}>
                                                                <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                                    Fecha Vencimiento Pasaporte (*)
                                                                </h5>
                                                            </Col>
                                                            <Col lg={8} md={8} sm={8} xs={12}>
                                                                <Input 
                                                                    type="date"
                                                                    value={datosFacturacion.fechaCaducidadPasaporte}
                                                                    onChange={(e) => handleCampoFacturacionChange('fechaCaducidadPasaporte', e.target.value)}
                                                                    invalid={!!errores.f_fechaCaducidadPasaporte}
                                                                />
                                                                {errores.f_fechaCaducidadPasaporte && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_fechaCaducidadPasaporte}</span>}
                                                            </Col>
                                                        </Row>

                                                        {/* Fecha Ingreso al País (*) */}
                                                        <Row className="mb-3 align-items-center">
                                                            <Col lg={4} md={4} sm={4} xs={12}>
                                                                <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                                    Fecha Ingreso al País (*)
                                                                </h5>
                                                            </Col>
                                                            <Col lg={8} md={8} sm={8} xs={12}>
                                                                <Input 
                                                                    type="date"
                                                                    value={datosFacturacion.fechaIngresoPais}
                                                                    onChange={(e) => handleCampoFacturacionChange('fechaIngresoPais', e.target.value)}
                                                                    invalid={!!errores.f_fechaIngresoPais}
                                                                />
                                                                {errores.f_fechaIngresoPais && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_fechaIngresoPais}</span>}
                                                            </Col>
                                                        </Row>
                                                    </React.Fragment>
                                                )}

                                                {/* 4. Nombres (*) / Razón Social (*) */}
                                                <Row className="mb-3 align-items-center">
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                            {datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '2' ? 'Razón Social (*)' : 'Nombres (*)'}
                                                        </h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Input 
                                                            type="text"
                                                            value={datosFacturacion.nombres}
                                                            onChange={(e) => handleCampoFacturacionChange('nombres', e.target.value.toUpperCase())}
                                                            invalid={!!errores.f_nombres}
                                                        />
                                                        {errores.f_nombres && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_nombres}</span>}
                                                    </Col>
                                                </Row>

                                                {/* 5. Apellidos (*) (No se muestra si es Ruc) */}
                                                {(!datosFacturacion.tipoDocumento || datosFacturacion.tipoDocumento.value !== '2') && (
                                                    <Row className="mb-3 align-items-center">
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                                Apellidos (*)
                                                            </h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Input 
                                                                type="text"
                                                                value={datosFacturacion.apellidos}
                                                                onChange={(e) => handleCampoFacturacionChange('apellidos', e.target.value.toUpperCase())}
                                                                invalid={!!errores.f_apellidos}
                                                            />
                                                            {errores.f_apellidos && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_apellidos}</span>}
                                                        </Col>
                                                    </Row>
                                                )}

                                                {/* 6. Estado Civil(*) (No se muestra si es Ruc) */}
                                                {(!datosFacturacion.tipoDocumento || datosFacturacion.tipoDocumento.value !== '2') && (
                                                    <Row className="mb-3 align-items-center">
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                                Estado Civil(*)
                                                            </h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Select 
                                                                options={OPCIONES_ESTADO_CIVIL}
                                                                value={datosFacturacion.estadoCivil}
                                                                onChange={(opt) => handleCampoFacturacionChange('estadoCivil', opt)}
                                                                placeholder="Seleccione el estado civil"
                                                                isSearchable={false}
                                                            />
                                                            {errores.f_estadoCivil && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_estadoCivil}</span>}
                                                        </Col>
                                                    </Row>
                                                )}

                                                {/* 7. Género(*) (No se muestra si es Ruc) */}
                                                {(!datosFacturacion.tipoDocumento || datosFacturacion.tipoDocumento.value !== '2') && (
                                                    <Row className="mb-3 align-items-center">
                                                        <Col lg={4} md={4} sm={4} xs={12}>
                                                            <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                                Género(*)
                                                            </h5>
                                                        </Col>
                                                        <Col lg={8} md={8} sm={8} xs={12}>
                                                            <Select 
                                                                options={OPCIONES_GENERO}
                                                                value={datosFacturacion.genero}
                                                                onChange={(opt) => handleCampoFacturacionChange('genero', opt)}
                                                                placeholder="Seleccione el género"
                                                                isSearchable={false}
                                                            />
                                                            {errores.f_genero && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_genero}</span>}
                                                        </Col>
                                                    </Row>
                                                )}

                                                {/* 8. Provincia(*) (Siempre visible) */}
                                                <Row className="mb-3 align-items-center">
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                            Provincia(*)
                                                        </h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Select 
                                                            options={provincias}
                                                            value={datosFacturacion.provincia}
                                                            onChange={(opt) => handleCampoFacturacionChange('provincia', opt)}
                                                            placeholder="Seleccione una provincia"
                                                            isSearchable={true}
                                                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        />
                                                        {errores.f_provincia && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_provincia}</span>}
                                                    </Col>
                                                </Row>

                                                {/* 9. Ciudad(*) (Siempre visible) */}
                                                <Row className="mb-3 align-items-center">
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                            Ciudad(*)
                                                        </h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Select 
                                                            options={ciudadesF}
                                                            value={datosFacturacion.ciudad}
                                                            onChange={(opt) => handleCampoFacturacionChange('ciudad', opt)}
                                                            placeholder="Seleccione una ciudad"
                                                            isSearchable={true}
                                                            isDisabled={!datosFacturacion.provincia}
                                                            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        />
                                                        {errores.f_ciudad && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_ciudad}</span>}
                                                    </Col>
                                                </Row>

                                                {/* 10. Fecha nacimiento(*) / Fecha de Constitución(*) */}
                                                <Row className="mb-3 align-items-center">
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                            {datosFacturacion.tipoDocumento && datosFacturacion.tipoDocumento.value === '2' ? 'Fecha de Constitución(*)' : 'Fecha nacimiento(*)'}
                                                        </h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Input 
                                                            type="date"
                                                            value={datosFacturacion.fechaNacimiento}
                                                            onChange={(e) => handleCampoFacturacionChange('fechaNacimiento', e.target.value)}
                                                            invalid={!!errores.f_fechaNacimiento}
                                                        />
                                                        {errores.f_fechaNacimiento && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_fechaNacimiento}</span>}
                                                    </Col>
                                                </Row>

                                                {/* 11. Correo Electrónico (*) */}
                                                <Row className="mb-3 align-items-center">
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                            Correo Electrónico (*)
                                                        </h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Input 
                                                            type="email"
                                                            value={datosFacturacion.correo}
                                                            onChange={(e) => handleCampoFacturacionChange('correo', e.target.value)}
                                                            invalid={!!errores.f_correo}
                                                        />
                                                        {errores.f_correo && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_correo}</span>}
                                                    </Col>
                                                </Row>

                                                {/* 12. Dirección (*) */}
                                                <Row className="mb-3 align-items-center">
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                            Dirección (*)
                                                        </h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Input 
                                                            type="text"
                                                            value={datosFacturacion.direccion}
                                                            onChange={(e) => handleCampoFacturacionChange('direccion', e.target.value.toUpperCase())}
                                                            invalid={!!errores.f_direccion}
                                                        />
                                                        {errores.f_direccion && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_direccion}</span>}
                                                    </Col>
                                                </Row>

                                                {/* 13. Celular (*) */}
                                                <Row className="mb-2 align-items-center">
                                                    <Col lg={4} md={4} sm={4} xs={12}>
                                                        <h5 style={{ fontSize: '15px', fontWeight: 'normal', margin: 0, color: '#222222' }}>
                                                            Celular (*)
                                                        </h5>
                                                    </Col>
                                                    <Col lg={8} md={8} sm={8} xs={12}>
                                                        <Input 
                                                            type="text"
                                                            value={datosFacturacion.celular}
                                                            onChange={(e) => handleCampoFacturacionChange('celular', e.target.value.replace(/[^0-9]/g, ''))}
                                                            invalid={!!errores.f_celular}
                                                        />
                                                        {errores.f_celular && <span className="text-danger" style={{ fontSize: '12px' }}>{errores.f_celular}</span>}
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    )}
                                </Col>

                                {/* Columna Derecha: Tarjeta de Valores Sticky */}
                                <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box" style={{ position: 'sticky', top: '20px', zIndex: 10 }}>
                                    <ValoresCotizacionMoto 
                                        valorTotal={valorTot}
                                        cotizacion={estadoMotos && estadoMotos.cotizacion}
                                        huboCambio={false}
                                        onIniciarEmision={handleContinuar}
                                        idCotizacion={idCotizacion}
                                        textoBotonEmision="CONTINUAR"
                                        requiereTerminos={true}
                                        mostrarDescargaYEnvio={false}
                                    />
                                </Col>
                            </Row>
                        )}
                    </Page>
                </div>
            </div>
        </LoadingScreen>
    );
};

const mapStateToProps = (state) => ({
    estadoMotos: state.dataMotos || state.motos || {}
});

const mapDispatchToProps = (dispatch) => ({
    obtenerCotizacionMoto: (idCarrito) => dispatch(obtenerCotizacionMoto(idCarrito)),
    limpiarDatosCotizacion: () => dispatch(limpiarDatosCotizacion()),
    guardarDatosFacturacionAction: (payload) => dispatch(FetchGuardarDatosFacturacion(payload))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FacturacionMoto);
